export { default } from './SeguroAuto25Banner';
